"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const reusables_1 = require("../../../comps/reusables");
const routeContainers_1 = require("../../../comps/routeContainers");
const graphql_1 = require("../../../graphql");
const ActiveCampaign_1 = require("./ActiveCampaign");
const CampaignMonitor_1 = require("./CampaignMonitor");
const ContentSystem_1 = require("./ContentSystem");
const ContentMappingList_1 = require("./ContentSystem/ContentMappingList");
const EspNav_1 = require("./EspNav");
const index_1 = require("./EspRequestPlayground/index");
const Mailchimp_1 = require("./Mailchimp");
const Mailjet_1 = require("./Mailjet");
const SailthruSettings_1 = require("./Sailthru/SailthruSettings");
const Salesforce_1 = require("./Salesforce");
const SalesforceSettings_1 = require("./Salesforce/SalesforceSettings");
const OsmosysResourcePage_1 = require("../../../comps/reusables/OsmosysResourcePage");
const EspPullSubscribers_1 = require("./EspPullSubscribers");
const EspPushSubscribers_1 = require("./EspPushSubscribers");
const EspHome_1 = require("./EspHome");
const react_if_1 = require("react-if");
const IntegrationAppSettings_1 = require("./IntegrationAppSettings");
const CmsNav_1 = require("./CmsNav");
const use_react_router_1 = tslib_1.__importDefault(require("use-react-router"));
const CmsHome_1 = require("./CmsHome");
exports.IntegrationDetail = ({ location }) => {
    const { match } = use_react_router_1.default();
    const isFull = location.pathname.match(/integrations\/\d+\/mappings\/\d+/);
    return (react_1.default.createElement(reusables_1.OsmosysResourcePage, { query: graphql_1.integration, paths: {
            item: 'integration',
        }, variables: { id: match.params.id }, getNav: data => {
            if (data.integration.isESP) {
                return (react_1.default.createElement(EspNav_1.EspNav, { activeTab: "", espId: match.params.id, esp: data.integration }));
            }
            return (react_1.default.createElement(CmsNav_1.CmsNav, { activeTab: "", cmsId: match.params.id, cms: data.integration }));
        }, getTitle: data => {
            const obj = data.integration;
            return obj.name;
        }, getSubTitle: data => {
            const obj = data.integration;
            return react_1.default.createElement(react_1.default.Fragment, null, obj.displayType);
        } },
        react_1.default.createElement(OsmosysResourcePage_1.OsmosysResourcePageInner, { container: !isFull }, (data, queryResult) => {
            const obj = data.integration;
            return (react_1.default.createElement(react_1.default.Fragment, null,
                react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/admin", component: IntegrationAppSettings_1.IntegrationAppSettings, componentProps: {
                        integration: obj,
                        location,
                        refetch: queryResult.refetch,
                    }, access: "admin" }),
                react_1.default.createElement(react_if_1.Switch, null,
                    react_1.default.createElement(react_if_1.Case, { condition: obj.integrationType === 'Sailthru' },
                        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/settings", component: SailthruSettings_1.SailthruSettings, componentProps: {
                                integration: obj,
                                location,
                                refetch: queryResult.refetch,
                            }, access: "workspaceAdmin" })),
                    react_1.default.createElement(react_if_1.Case, { condition: obj.integrationType === 'Salesforce' },
                        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/settings", component: SalesforceSettings_1.SalesforceSettings, componentProps: {
                                integration: obj,
                                location,
                                refetch: queryResult.refetch,
                            }, access: "workspaceAdmin" })),
                    react_1.default.createElement(react_if_1.Case, { condition: obj.integrationType === 'Mailchimp' },
                        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/settings", component: Mailchimp_1.MailchimpSettings, componentProps: {
                                integration: obj,
                                location,
                                refetch: queryResult.refetch,
                            }, access: "workspaceAdmin" })),
                    react_1.default.createElement(react_if_1.Case, { condition: obj.integrationType === 'Mailjet' },
                        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/settings", component: Mailjet_1.MailjetSettings, componentProps: {
                                integration: obj,
                                location,
                                refetch: queryResult.refetch,
                            }, access: "workspaceAdmin" })),
                    react_1.default.createElement(react_if_1.Case, { condition: obj.integrationType === 'ActiveCampaign' },
                        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/settings", component: ActiveCampaign_1.ActiveCampaignSettings, componentProps: {
                                integration: obj,
                                location,
                                refetch: queryResult.refetch,
                            }, access: "workspaceAdmin" })),
                    react_1.default.createElement(react_if_1.Case, { condition: obj.integrationType === 'CampaignMonitor' },
                        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/settings", component: CampaignMonitor_1.CampaignMonitorSettings, componentProps: {
                                integration: obj,
                                location,
                                refetch: queryResult.refetch,
                            }, access: "workspaceAdmin" })),
                    react_1.default.createElement(react_if_1.Case, { condition: obj.integrationType === 'ContentSystem' },
                        react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/settings", component: ContentSystem_1.ContentSystemSettings, componentProps: {
                                integration: obj,
                                location,
                                refetch: queryResult.refetch,
                            }, access: "workspaceAdmin" }))),
                react_1.default.createElement(react_if_1.When, { condition: obj.integrationType === 'Salesforce' },
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id/:subResource(api-explorer)", component: Salesforce_1.SalesforceApiExplorer, componentProps: {
                            integration: data.integration,
                        }, access: "admin" })),
                react_1.default.createElement(react_if_1.When, { condition: obj.integrationType === 'ContentSystem' },
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id", component: CmsHome_1.CmsHome, componentProps: {
                            integration: data.integration,
                        } }),
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id/feeds", component: ContentSystem_1.ContentFeedList, componentProps: {
                            integration: data.integration,
                        } }),
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { path: "/integrations/:id/feeds/:contentFeedId", component: ContentSystem_1.ContentFeedCanvas, componentProps: {
                            integration: data.integration,
                        } }),
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id/mappings", component: ContentMappingList_1.ContentMappingList, componentProps: {
                            integration: data.integration,
                        } }),
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id/conversions", component: ContentSystem_1.ContentConversionList, componentProps: {
                            integration: data.integration,
                        } })),
                react_1.default.createElement(react_if_1.When, { condition: !!obj.isESP },
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id", component: EspHome_1.EspHome, componentProps: {
                            integration: data.integration,
                        } }),
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id/:subResource(playground)", component: index_1.EspRequestPlayground, componentProps: {
                            integration: data.integration,
                        }, access: "admin" }),
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id/:subResource(subscribers/update)", component: EspPushSubscribers_1.EspPushSubscribers, componentProps: {
                            integration: data.integration,
                        }, access: "admin" }),
                    react_1.default.createElement(routeContainers_1.OsmosysRoute, { exact: true, path: "/integrations/:id/:subResource(subscribers/download)", component: EspPullSubscribers_1.EspPullSubscribers, componentProps: {
                            integration: data.integration,
                        }, access: "admin" }))));
        })));
};
exports.default = exports.IntegrationDetail;
//# sourceMappingURL=index.js.map